import { createAction } from '@lingoda/core';

export const revalidateBookingFilter = createAction('booking/REVALIDATE_BOOKING_FILTER');
